<div class="ai-hub-form pl-3 mt-3">
	<div class="d-flex justify-content-between">
		<div [routerLink]="''" class="cursor-pointer">
			<img src="./assets/img/asset-logo.svg" class="asset-logo" />
			<h4 class="d-inline-block">IQGen</h4>
		</div>
		<div>
			<a class="cursor-pointer input-element" (click)="prefillSampleData()" href="javascript:void(0)">
				<img src="./assets/img/prefill.svg" alt="Prefill data" />
				Prefill sample data
			</a>
		</div>
	</div>

	<form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="showForm">
		<div *ngFor="let control of formJson">
			<!-- Text -->
			<div *ngIf="control.type === 'text'" class="input-element">
				<label>{{ control.label }}</label>
				<input
					type="text"
					formControlName="{{ control.name }}"
					[placeholder]="control.placeholder"
					class="w-100" />
			</div>

			<!-- Dropdown -->
			<div *ngIf="control.type === 'dropdown'" class="input-element">
				<label>{{control.label}}</label>
				<mat-form-field appearance="fill">
					<mat-label>Select...</mat-label>
					<mat-select formControlName="{{control.name}}">
						<mat-option *ngFor="let option of control.options" [value]="option">
							{{option}}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<!-- Audio -->
			<div *ngIf="control.type === 'audio'" class="input-element">
				<label>{{ control.label }}</label>
				<app-audio></app-audio>
			</div>

			<!-- Toggle -->
			<div *ngIf="control.type === 'toggle'" class="input-element">
				<mat-slide-toggle formControlName="{{ control.name }}">
					Include emoticons in the post ?
				</mat-slide-toggle>
			</div>

			<!-- Textarea -->
			<div *ngIf="control.type === 'textarea'" class="input-element">
				<label>{{ control.label }}</label>
				<textarea
					formControlName="{{ control.name }}"
					rows="3"
					[placeholder]="control.placeholder"
					class="w-100"></textarea>
			</div>

			<!-- Upload -->
			<!-- <div *ngIf="control.type === 'upload' && showUpload" class="input-element">
				<label>{{ control.label }}</label>
				<ngx-file-drop
					(onFileDrop)="drop($event)"
					[dropZoneClassName]="'asset-logo--dropzone'"
					[showBrowseBtn]="false"
					[accept]="'.pdf'"
					[multiple]="false">
					<ng-template
						ngx-file-drop-content-tmp
						let-openFileSelector="openFileSelector">
						<button type="button" (click)="openFileSelector()">
							<img src="./assets/img/upload.svg" alt />
						</button>
						<p class="text mb-1">Browse & Upload</p>
						<small class="text-black">Only .pdf files are allowed.</small>
					</ng-template>
				</ngx-file-drop>
				<div class="file-name-div py-2 text-center" *ngIf="fileName">
					<p class="text d-inline-block mr-3 mb-0">
						<img src="./assets/img/pdf.svg" class="image-fluid" *ngIf="fileType.includes('pdf')">
						{{fileName}}
					</p>
					<mat-icon class="cursor-pointer" (click)="clearFile()">close</mat-icon>
				</div>
			</div> -->
		</div>

		<button class="btn btn-primary input-element" type="submit()" [disabled]="!submitEnabled()">
			Generate
		</button>
	</form>
</div>
